import { render, staticRenderFns } from "./DemandDetail.vue?vue&type=template&id=ddc40fb4&scoped=true"
import script from "./DemandDetail.vue?vue&type=script&lang=js"
export * from "./DemandDetail.vue?vue&type=script&lang=js"
import style0 from "./DemandDetail.vue?vue&type=style&index=0&id=ddc40fb4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc40fb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddc40fb4')) {
      api.createRecord('ddc40fb4', component.options)
    } else {
      api.reload('ddc40fb4', component.options)
    }
    module.hot.accept("./DemandDetail.vue?vue&type=template&id=ddc40fb4&scoped=true", function () {
      api.rerender('ddc40fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Modal/DemandDetail.vue"
export default component.exports